import React from 'react';

export const Section = ({
  children,
  className = '',
  containerClassName = '',
  divider = false,
  id,
}) => (
  <section
    id={id}
    className={`py-24 lg:py-36 ${divider ? 'border-t border-secondary-200' : ''} ${className}`}
  >
    <div
      className={`max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 ${containerClassName}`}
    >
      {children}
    </div>
  </section>
);

// Editorial section heading: small sage eyebrow, large left-aligned serif
// title in a controlled measure, one quiet line of intro. No centering,
// no decoration — the type does the work.
export const SectionHeading = ({
  eyebrow,
  title,
  intro,
  className = '',
}) => (
  <div className={`max-w-3xl ${className}`}>
    {eyebrow && (
      <p className="text-[11px] font-semibold text-primary-700 uppercase tracking-[0.2em] mb-6">
        {eyebrow}
      </p>
    )}
    <h2 className="font-serif text-3xl md:text-4xl lg:text-[2.75rem] font-normal text-secondary-900 leading-[1.15] tracking-tight">
      {title}
    </h2>
    {intro && (
      <p className="text-lg text-secondary-600 mt-6 leading-relaxed max-w-2xl">
        {intro}
      </p>
    )}
  </div>
);

export default Section;
